<P [innerHTML] ="templatePreview =='' ?'': templatePreview | safeHTMLtags: 'html'"></P>